import { Card } from '../common/Card';
import type { VpsStatus } from '../../types/vps';

interface VpsConnectionCardProps {
  status: VpsStatus | null;
}

const VPS_IP = '129.212.189.254';

export function VpsConnectionCard({ status }: VpsConnectionCardProps) {
  const connected = status?.connected ?? false;

  return (
    <Card title="Connection">
      <div className="flex flex-col items-center gap-3 py-2">
        <div
          className={`h-16 w-16 rounded-full ${
            connected ? 'bg-success shadow-[0_0_12px_rgba(34,197,94,0.4)]' : 'bg-error shadow-[0_0_12px_rgba(239,68,68,0.4)]'
          }`}
        />
        <span className={`text-lg font-semibold ${connected ? 'text-success' : 'text-error'}`}>
          {connected ? 'Connected' : 'Offline'}
        </span>
        <span className="text-sm text-text-muted">{VPS_IP}</span>
        {status?.uptime ? (
          <span className="text-sm text-text-secondary">Uptime: {status.uptime}</span>
        ) : null}
        {status?.error ? (
          <span className="text-sm text-error">{status.error}</span>
        ) : null}
      </div>
    </Card>
  );
}

export default VpsConnectionCard;
